import { Grid } from '@mui/material';

function FormGrid({ children, ...props }){
  return(
    <Grid container justifyContent='center'>
      <Grid container item spacing={2} xs={12} md={12} lg={12} xl={8} {...props}>
        {children}
      </Grid>
    </Grid>
  )
} export default FormGrid;